import { render, staticRenderFns } from "./CheckboxesFeatureField.vue?vue&type=template&id=22e45761&"
import script from "./CheckboxesFeatureField.vue?vue&type=script&lang=js&"
export * from "./CheckboxesFeatureField.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxesFeatureField.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports